module.exports = __webpack_public_path__ + "img/violet_097.30c25cd9.png";